<template>
  <div>
    <div class="dashboard-rh">
      <div class="row mx-0">
        <div class="item bg-gradient-info col-12 col-md-6 p-2">
          <img
            src="@/assets/images/lines.svg"
            class="card-img-absolute"
            alt="circle-image"
          />
          <div class="text-center">Total de horas alocadas</div>
          <h4 class="mt-2 text-center text-white">{{ totalHoras }} Hrs</h4>
        </div>
        <div class="item bg-gradient-success col-12 col-md-6 p-2">
          <img
            src="@/assets/images/lines.svg"
            class="card-img-absolute"
            alt="circle-image"
          />
          <div class="text-center">Valor total</div>
          <h4 class="mt-2 text-center text-white">{{ totalValor }}</h4>
        </div>
      </div>
    </div>
    <select-modal
      id="propostaRH"
      placeholder-button="Inserir"
      :modal-fields="colunasModal"
      :fields="colunasTabela"
      :fetch-method="fetchMethod"
      term-initial="nome"
      :values="dados"
      slot-image="foto"
      @update="inserir"
      @edit="editar"
      @remove="remover"
      titleModal="RECUSOS HUMANOS"
      hide-selected
      class="p-3"
      :function-map="
        (el) => {
          return el.pessoa.id;
        }
      "
      :controles="!aprovada"
      :btn-inserir="permissaoPessoas.c"
      btn-tipo="pessoas"
      :esconder-inserir="!permissaoRH.c"
      :esconder-editar="!permissaoRH.u"
      :esconder-excluir="!permissaoRH.d"
    >
      <template #table>
        <tabela
          :duracao="duracao"
          :itens="dados"
          :esconder-editar="!permissaoRH.u || aprovada"
          :esconder-excluir="!permissaoRH.d || aprovada"
          controles
          @atualizar="atualizar"
          @deletar="remover"
          ref="tabela"
        />
      </template>
    </select-modal>
  </div>
</template>
<script>
import SelectModal from "@/components/modal/SelectModal";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";

import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import Tabela from "./Tabela";

export default {
  name: "PropostaRecursosHumanos",
  mixins: [FormMixin, AlertasMixin],
  props: {
    propostaId: {
      required: true,
    },
    duracao: {
      default: 0,
    },
    aprovada: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
    },
  },
  components: {
    SelectModal,
    Tabela,
  },
  data: () => ({
    colunasModal: [
      { key: "acoes", label: "Ações", tdClass: "acoes" },
      { key: "foto", label: "" },
      { key: "nome", label: "Nome" },
      { key: "email", label: "E-mail" },
      { key: "endereco.cidade", label: "Cidade" },
      { key: "titulacao", label: "Titulação" },
    ],
    colunasTabela: [
      { key: "foto", label: "" },
      { key: "pessoa.nome", label: "Nome" },
      { key: "pessoa.nacionalidade", label: "Nacionalidade" },
      { key: "pessoa.titulacao", label: "Titulação" },
      {
        key: "funcao",
        label: "Função",
        formatter: (value) => {
          if (value != "SemFuncao") return helpers.getEnum(value).text;
        },
      },
      {
        key: "valorHora",
        label: "Valor hora",
        formatter: (value) => {
          if (value) return helpers.formatarValor(value);
        },
      },
      {
        key: "horasSazonais",
        label: "Horas alocadas",
        formatter: (value) => {
          if (value)
            return value.reduce((total, hora) => total + parseInt(hora.horas), 0);
        },
      },
      {
        key: "valor_total",
        label: "Valor total(R$)",
        formatter: (value, key, item) => {
          return helpers.formatarValor(
            item.valorHora *
              (item.horasSazonais
                ? item.horasSazonais.reduce(
                    (total, hora) => total + parseInt(hora.horas),
                    0
                  )
                : 0)
          );
        },
      },
      { key: "actions", label: "Ações" },
    ],
    dados: [],
    tabelaRH: [],
    form: {
      id: null,
      funcaoId: null,
      valorHora: "",
      tipoHora: "horas_sazonais",
      horasSazonais: [],
      quantidadeHorasMensais: 0,
    },
    filtro: "",
  }),
  methods: {
    fetchMethod: function () {
      return PessoaService.listar(this.empresaSelecionada.id);
    },
    inserir: function (pessoa) {
      let form = {
        propostaId: this.propostaId,
        pessoaId: pessoa.item.id,
      };

      PropostaService.salvarRH(form)
        .then(() => {
          this.toastSucesso("Pessoa adicionada com sucesso!");
          this.buscar();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.toastErro(err.response.data.errors);
          } else {
            this.toastErro("Erro ao adicionar pessoa!");
          }
        });
    },

    atualizar: function (rh = null) {
      if (rh) {
        if (!this.$refs.tabela.validarFormulario(`tabela-${rh.id}`)) return;
        this.form = cloneDeep(rh);
        this.form.alocacaoHoraIndividualId = this.form.id;
        this.form.propostaId = this.propostaId;
        this.form.EmpresaId = this.empresaSelecionada.id;
      }

      this.confirmar("Deseja salvar alterações?").then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);

        let form = cloneDeep(this.form);

        form.horasSazonais.forEach((element) => {
          if (!element.horas) element.horas = 0;
        });

        form.valorHora = form.valorHora
          .replace("R$ ", "")
          .replace(/\./g, "")
          .replace(",", ".");

        PropostaService.salvarRH(form)
          .then(() => {
            this.alertaSucesso("Salvo com sucesso!").then(() => {
              this.$nextTick(() => {
                this.$bvModal.hide("modal-edit-rh");
              });
              this.buscar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else {
              this.alertaErro("Erro ao salvar!");
            }
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    editar: function (person) {
      let pessoa = cloneDeep(person);

      this.form = {
        alocacaoHoraIndividualId: pessoa.id,
        propostaId: this.propostaId,
        funcao: pessoa.funcao,
        valorHora: pessoa.valorHora ? helpers.formatarValor(pessoa.valorHora) : "0",
        tipoHora: "horas_sazonais",
        horasSazonais: pessoa.horasSazonais.sort((a, b) => {
          if (a.mes > b.mes) return 1;

          if (a.mes < b.mes) return -1;
        }),
        quantidadeHorasMensais: 0,
      };

      for (let index = this.form.horasSazonais.length; index < this.duracao; index++) {
        this.form.horasSazonais.push({
          mes: index + 1,
          horas: 0,
        });
      }

      this.$bvModal.show("modal-edit-rh");
    },

    remover: function (person) {
      this.confirmar("Deseja remover pessoa?").then((confirmado) => {
        if (!confirmado) return;

        let form = {
          alocacaoHoraIndividualId: person.id,
          propostaId: this.propostaId,
        };

        this.$store.dispatch(START_LOADING);

        PropostaService.removerRH(form)
          .then(() => {
            this.alertaSucesso("Pessoa excluída com sucesso!").then(() => {
              this.buscar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(err.response.data.errors);
            } else {
              this.alertaErro("Erro ao salvar!");
            }
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    formatarValor: function (v) {
      if (v) {
        return helpers.formatarValor(v);
      } else {
        return helpers.formatarValor(0);
      }
    },

    removerValor: function (v) {
      return helpers.removerValor(v);
    },

    getHorasSazonais: function (rh, mes) {
      let horas = rh.horasSazonais.find((hora) => hora.mes == mes);
      if (horas) return horas;

      rh.horasSazonais.push({
        mes: mes,
        horas: 0,
      });

      return this.getHorasSazonais(rh, mes);
    },

    buscar: function () {
      this.$store.dispatch(START_LOADING);
      PropostaService.buscarRH(this.propostaId)
        .then((res) => {
          this.dados = cloneDeep(res.data.data.equipe.alocacaoHorasIndividuais);
          this.tabelaRH = cloneDeep(res.data.data.equipe.alocacaoHorasIndividuais).map(
            (el) => {
              el.valorHora = helpers.formatarValor(el.valorHora || 0);
              el.edit = false;
              return el;
            }
          );
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    montar() {
      this.buscar();
    },
  },
  computed: {
    permissaoRH() {
      return this.$store.getters["app/retornaPermissao"]("PropostaRecursoHumano");
    },
    permissaoPessoas() {
      return this.$store.getters["app/retornaPermissao"]("Pessoas");
    },
    horasSazonais: function () {
      let horas = [];
      for (let index = 1; index <= this.duracao; index++) {
        let quantidade = 0;
        this.tabelaRH.forEach((element) => {
          quantidade += element.horasSazonais.find((el) => el.mes == index)
            ? element.horasSazonais.find((el) => el.mes == index).horas
            : 0;
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },

    totalHoras: function () {
      return this.tabelaRH.reduce(
        (total, pessoa) =>
          total +
          parseInt(
            pessoa.horasSazonais.reduce((total, hora) => total + parseInt(hora.horas), 0)
          ),
        0
      );
    },

    totalValor: function () {
      return helpers.formatarValor(
        this.tabelaRH.reduce((total, pessoa) => {
          return (
            total +
            parseInt(
              pessoa.horasSazonais.reduce(
                (total, hora) => total + parseInt(hora.horas),
                0
              )
            ) *
              this.removerValor(pessoa.valorHora || "0")
          );
        }, 0)
      );
    },
    mesesDepesas() {
      return helpers.criarArrayMes(`2022-01-01`, this.duracao, true);
    },
    empresaSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },
  },
};
</script>
<style lang=""></style>
